// src/components/Sidebar.jsx
import { C } from "../styles/tokens";
import { Icon } from "./UI";

const NAV_ITEMS = [
  { id: "dashboard", icon: "dashboard", label: "Dashboard"      },
  { id: "inventory", icon: "drop",      label: "Blood Inventory" },
  { id: "requests",  icon: "send",      label: "Blood Requests"  },
  { id: "donors",    icon: "people",    label: "Donors"          },
  { id: "profile",   icon: "person",    label: "Profile"         },
  { id: "settings",  icon: "settings",  label: "Settings"        },
];

export default function Sidebar({ active, setActive, onLogout, open }) {
  return (
    <div
      className={`sidebar ${open ? "open" : ""}`}
      style={{
        width: 220,
        background: C.card,
        borderRight: `1px solid ${C.border}`,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        position: "sticky",
        top: 0,
        flexShrink: 0,
        zIndex: 50,
      }}
    >
      {/* Logo */}
      <div style={{ padding: "20px 16px 16px", borderBottom: `1px solid ${C.border}` }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 36, height: 36,
              background: "rgba(198,40,40,.2)",
              borderRadius: 10,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >
            <Icon name="drop" size={20} color={C.red} />
          </div>
          <div>
            <div className="syne" style={{ fontSize: 15, fontWeight: 900, color: C.text, lineHeight: 1 }}>
              BloodBridge
            </div>
            <div style={{ fontSize: 10, color: C.muted, marginTop: 2 }}>Hospital Portal</div>
          </div>
        </div>
      </div>

      {/* Hospital badge */}
      <div style={{ padding: "12px 16px", borderBottom: `1px solid ${C.border}` }}>
        <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
          <div
            style={{
              width: 32, height: 32,
              background: "rgba(198,40,40,.15)",
              borderRadius: 8,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >
            <Icon name="hospital" size={16} color={C.red} />
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 700, color: C.text }}>City General Hosp.</div>
            <div style={{ fontSize: 10, color: C.muted }}>Vadodara, GJ</div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ padding: "12px 10px", flex: 1, overflowY: "auto" }}>
        <div
          style={{
            fontSize: 10, color: C.muted, fontWeight: 700,
            letterSpacing: 0.8, padding: "0 6px", marginBottom: 8,
          }}
        >
          MAIN MENU
        </div>

        {NAV_ITEMS.map((item) => (
          <div
            key={item.id}
            className={`nav-item ${active === item.id ? "active" : ""}`}
            onClick={() => setActive(item.id)}
          >
            <Icon
              name={item.icon}
              size={17}
              color={active === item.id ? C.red : C.muted}
            />
            <span>{item.label}</span>
          </div>
        ))}
      </nav>

      {/* Sign out */}
      <div style={{ padding: "12px 10px", borderTop: `1px solid ${C.border}` }}>
        <div className="nav-item" onClick={onLogout} style={{ color: "#EF9A9A" }}>
          <Icon name="logout" size={16} color="#EF9A9A" />
          <span>Sign Out</span>
        </div>
      </div>
    </div>
  );
}